export const DATA_CHANGE_TYPES = {
  name: 'changed name',
  phone: 'changed phone',
  address: 'changed address',
  city: 'changed city',
  department: 'changed department',
  location: 'changed location',
  email: 'changed email'
}

const LOCATION_PAIR_MS = 15000

function mapHistoryDisplayValue (entry) {
  return (entry.to || entry.from || '').trim() || '—'
}

function buildHistoryDisplayEntries (entries) {
  return entries
    .slice()
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    .map((entry, index) => ({
      from: mapHistoryDisplayValue(entry),
      createdAt: entry.createdAt,
      createdBy: entry.createdBy,
      change: entry.change,
      isCurrent: index === 0
    }))
}

export function getDataHistoryByType (order, changeType) {
  const entries = (order && order.noveltyData) || []
  return buildHistoryDisplayEntries(
    entries.filter(entry => entry.change === changeType)
  )
}

export function hasDataHistory (order) {
  const entries = (order && order.noveltyData) || []
  return entries.length > 0
}

function mergeLocationPair (city, department) {
  if (city && department) return `${city} - ${department}`
  if (city) return city
  if (department) return department
  return '—'
}

function groupLegacyLocationEntries (entries) {
  const locationEntries = entries
    .filter(entry => entry.change === DATA_CHANGE_TYPES.city || entry.change === DATA_CHANGE_TYPES.department)
    .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))

  const groups = []

  for (const entry of locationEntries) {
    const group = groups.find(item =>
      item.createdBy === entry.createdBy &&
      Math.abs(new Date(item.createdAt) - new Date(entry.createdAt)) <= LOCATION_PAIR_MS &&
      ((entry.change === DATA_CHANGE_TYPES.city && !item.city) ||
        (entry.change === DATA_CHANGE_TYPES.department && !item.department))
    )

    if (group) {
      if (entry.change === DATA_CHANGE_TYPES.city) group.city = entry
      if (entry.change === DATA_CHANGE_TYPES.department) group.department = entry
      continue
    }

    groups.push({
      city: entry.change === DATA_CHANGE_TYPES.city ? entry : null,
      department: entry.change === DATA_CHANGE_TYPES.department ? entry : null,
      createdAt: entry.createdAt,
      createdBy: entry.createdBy
    })
  }

  return groups
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    .map(group => ({
      change: DATA_CHANGE_TYPES.location,
      createdAt: group.createdAt,
      createdBy: group.createdBy,
      from: mergeLocationPair(group.city && group.city.from, group.department && group.department.from),
      to: mergeLocationPair(group.city && group.city.to, group.department && group.department.to)
    }))
}

export function getLocationHistoryEntries (order) {
  const entries = (order && order.noveltyData) || []
  const combined = entries.filter(entry => entry.change === DATA_CHANGE_TYPES.location)

  if (combined.length) {
    return buildHistoryDisplayEntries(combined)
  }

  return buildHistoryDisplayEntries(groupLegacyLocationEntries(entries))
}



// WEBPACK FOOTER //
// ./src/helpers/orderDataHistory.js